import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HttpService } from '../../services/http.service';
import { PreloaderService } from './preloader.service';
import { EnvironmentService } from '../../services';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss']
})
export class PreloaderComponent implements OnInit, OnDestroy {

  private loader$: Subscription;
  public isLoading: boolean;
  public theme: string;

  constructor(
    public httpService: HttpService,
    public preLoaderService: PreloaderService,
    public envService: EnvironmentService
  ) {
    this.isLoading = false;

    this.theme = this.envService.getTheme();
  }

  ngOnInit() {
    // Subscribing PreLoader Seervice
    this.loader$ = this.preLoaderService.isLoaderChange.subscribe(
      (isLoading: boolean) => {
        this.isLoading = isLoading;
      }
    );
  }

  ngOnDestroy() {
    if (this.loader$) {
      this.loader$.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/preloader/preloader.component.ts